
import { getThemeColor } from "@/branding";
import { computed, defineComponent, PropType, inject } from "vue";
import {
  FormValidatedValuesKey,
  FormValidatedUpdateKey,
  FormValidatedErrorsKey,
} from "../../types/inject";

export default defineComponent({
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    items: {
      type: Array as PropType<
        {
          name: string;
          value: number | string;
          icon?: string;
          disabled?: boolean;
          disabledTitle?: string;
        }[]
      >,
      required: true,
    },
    tclass: String,
  },
  setup(props) {
    const values = inject(FormValidatedValuesKey, {});
    const errors = inject(FormValidatedErrorsKey, {});

    const onUpdate = inject(FormValidatedUpdateKey);

    const onSelect = (item: { value: number | string; disabled?: boolean }) => {
      if (item.disabled) {
        return;
      }

      typeof onUpdate === "function" && onUpdate({ [props.name]: item.value });
    };

    return {
      onSelect,
      theme: getThemeColor(),
      value: computed(() => values[props.name]),
      error: computed(() => errors[props.name]),
    };
  },
});
